'use client';

import { useCallback, useContext } from 'react';

import { Locale, ModalContext } from '@shared/libs';

import styles from './registration-btn.module.css';
import { RegistrationForm } from './registration-form';

type Props = {
  locale: Locale;
  onCloseParentModal?: () => void;
};

export const RegistrationBtn = ({ locale, onCloseParentModal }: Props) => {
  const openModal = useContext(ModalContext);

  const handleClick = useCallback(() => {
    onCloseParentModal?.();
    openModal({
      modal: {
        title: locale.PAGE_PERSONAL_REGISTRATION_TITLE || 'PAGE_PERSONAL_REGISTRATION_TITLE',
        // eslint-disable-next-line react/no-unstable-nested-components
        Content: (props) => <RegistrationForm {...props} locale={locale} />,
      },
    });
  }, [locale, openModal, onCloseParentModal]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <p className={styles.registration} onClick={handleClick}>
      {locale.PAGE_PERSONAL_REGISTRATION || 'PAGE_PERSONAL_REGISTRATION'}
    </p>
  );
};
